import { css } from '@emotion/core';
import {
  helpText,
  secondaryText,
  shadowFrame,
  shadowFrameSelected,
  Theme,
} from 'features/Theme';
import { fade } from '@material-ui/core/styles/colorManipulator';

const styles = {
  banner: (theme: Theme) => css`
    ${helpText(theme)}
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    background-color: ${theme.mui.palette.primary.main};
    color: ${theme.mui.palette.primary.contrastText};
    padding: ${theme.mui.spacing(1)}px;
    font-weight: bold;
  `,
  bannerSecondaryText: (theme: Theme) => css`
    ${secondaryText(theme)}
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-transform: initial;
    background-color: ${theme.mui.palette.primary.main};
    color: ${theme.mui.palette.primary.contrastText};
    padding: ${theme.mui.spacing(1)}px ${theme.mui.spacing(1.5)}px
      ${theme.mui.spacing(0.75)}px;
  `,
  panel: (theme: Theme) => css`
    border-radius: ${theme.shape.borderRadiusLarge}px
      ${theme.shape.borderRadiusLarge}px;
    overflow: hidden;
    transition: ${theme.mui.transitions.create(['box-shadow', 'height'])};
    ${shadowFrame()};
    .MuiExpansionPanel-root {
      background-color: transparent;
    }

    .MuiStepper-root {
      // FIXME: should not be styled here
      background-color: transparent;
    }
    .MuiExpansionPanelSummary-content {
      margin: ${theme.mui.spacing(2)}px 0;
    }

    .MuiExpansionPanelDetails-root {
      padding: 0;
    }
  `,
  /**
   * The following CSS is intended to mimic the style of the summary area of
   * the Expansion panel when the panel is not expandable.
   * It needs to be kept in sync with that.
   */
  nonExpandableSummary: (theme: Theme) => css`
    margin: ${theme.mui.spacing(2)}px 0;
    padding: 0 ${theme.mui.spacing(3)}px;
    display: flex;
  `,

  expansionDetailsContent: (theme: Theme) => css`
    padding: ${theme.mui.spacing(2)}px ${theme.mui.spacing(3)}px;
  `,
  footer: (theme: Theme) => css`
    padding: ${theme.mui.spacing(2)}px ${theme.mui.spacing(3)}px;
    background-color: ${theme.mui.palette.common.white};
  `,

  expanded: (theme: Theme) => css`
    background-color: ${fade(theme.mui.palette.primary.main, 0.06)};
    ${shadowFrameSelected()}

    .MuiExpansionPanel-root.Mui-expanded {
      margin: auto;
    }
    .MuiExpansionPanelSummary-content.Mui-expanded {
      margin: ${theme.mui.spacing(2)}px 0;
    }
  `,
  expansionDetails: css`
    flex-direction: column;
  `,
};

export default styles;
